import * as Roles from 'constants/roles';

export const userRole = ({ is_mac_admin, is_brand_admin, is_mac_super_admin, is_brand_owner }) => {
  if (is_mac_super_admin) return Roles.SUPER_ADMIN;
  if (is_mac_admin) return Roles.ADMIN;
  if (is_brand_admin) return Roles.BRAND_ADMIN;
  if (is_brand_owner) return Roles.OWNER;
  return Roles.MANAGER;
};
